import * as React from "react";
import { SVGProps } from "react";
export const NavigationFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.333 11.667L3.083 9.54204C2.90233 9.47271 2.76 9.36137 2.656 9.20804C2.552 9.05537 2.5 8.88204 2.5 8.68804C2.5 8.49337 2.552 8.32304 2.656 8.17704C2.76 8.03104 2.90233 7.92337 3.083 7.85404L15.708 3.16704C15.8887 3.09704 16.059 3.08637 16.219 3.13504C16.3783 3.18371 16.5137 3.26371 16.625 3.37504C16.7363 3.48637 16.8163 3.62171 16.865 3.78104C16.9137 3.94104 16.903 4.11137 16.833 4.29204L12.146 16.938C12.0627 17.132 11.9447 17.2744 11.792 17.365C11.6387 17.455 11.4787 17.5 11.312 17.5C11.1453 17.5 10.9857 17.4514 10.833 17.354C10.6803 17.2567 10.5623 17.118 10.479 16.938L8.333 11.667Z"
            fill="currentColor"
        />
    </svg>
);
NavigationFillIcon.displayName = "NavigationFillIcon";
